import styled from 'styled-components';

export const Container = styled.div`
	padding-bottom: 10px;
`;
